
export const sFechaPublicacion = '2026-10-15T14:28:58.6777695-06:00';
export const sVersion = 'vf1.1.610151428';
            